//
import ProviderService from './ProviderService'

//
export default ProviderService
